import { combineReducers } from 'redux'
import currentUser from './get-current-user'
import selected from './get-one'
import editOne from './edit'
import newOne from './new'
import all from './get-all'
import deleteMedia from './delete-media'
import updateCurrentUser from './update-current-user'

const reducer = combineReducers({
  selected,
  currentUser,
  all,
  editOne,
  newOne,
  deleteMedia,
  updateCurrentUser
})

export default reducer
